export const SESSION_TOKEN_PARAM = "tastyworks-token"
export const LEGACY_SESSION_TOKEN_PARAM = "token"
export const HANDOFF_SOURCE_PARAM = "handoff-source"
export const AUTH_MODE_PARAM = "handoff-auth-mode"

export const SESSION_TOKEN_PARAMS = [
  SESSION_TOKEN_PARAM,
  LEGACY_SESSION_TOKEN_PARAM,
] as const

export const RESERVED_PARAMS = [
  ...SESSION_TOKEN_PARAMS,
  HANDOFF_SOURCE_PARAM,
  AUTH_MODE_PARAM,
] as const

export const RETIRED_PARAMS = ["is-handoff"] as const

const ABSENT_TOKEN_VALUES: readonly string[] = ["null", "undefined"]

export function isUsableToken(value: string | null): value is string {
  return value !== null && value !== "" && !ABSENT_TOKEN_VALUES.includes(value)
}
